// @ngInject
function connectVitalArticleInformationDialogService($uibModal){
    return {
        showDialog: showDialog
    };

    function showDialog(vitalChanges, isAutoOpened = false){
        var modalDefaults = {
            backdrop: 'static',
            keyboard: false,
            controller: 'connectVitalArticleInformationDialogController as vm',
            templateUrl: 'main/product/productimporteditor/dialogs/connectVitalArticleInformationDialog.tpl.html',
            size: 'lg',
            resolve: {
                vitalChangesObject: function (){
                    return vitalChanges;
                },
                isAutoOpened: function (){
                    return isAutoOpened
                }
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function connectVitalArticleInformationDialogController($scope, vitalChangesObject, isAutoOpened, $uibModalInstance, loadSpinnerService, ToasterService, $translate) {
    var vm = this;

//Variables
    vm.vitalChanges = angular.copy(vitalChangesObject);
    vm.paginatedChanges = [];
    vm.pagination = {
        current: 1,
        total: 1,
        max: 15,
        items: 0
    }
    vm.fieldDefinitions = [                         
        { key: 'AlternativeArticleNumber', label: 'productimport.alternativeArticleNumber'},
        { key: 'ArticleName', label: 'productimport.articleName'},                          
        { key: 'ArticleDescription', label: 'productimport.articleDescription'},                      
        { key: 'DepartmentCode', label: 'productimport.department'},   
        { key: 'ItemGroupCode', label: 'productimport.itemgroup'},                     
        { key: 'SubCategoryCode', label: 'productimport.subCategory'},          
        { key: 'Variant1Name', label: 'productimport.variant1Name'},                        
        { key: 'Variant2Name', label: 'productimport.variant2Name'},        
    ];
    vm.disableAuto = false;
    vm.isAutoOpened = isAutoOpened;
    vm.expandAll = false;

//Functions
    vm.refresh = refresh;
    vm.closeModal = closeModal;
    vm.toggleExpand = toggleExpand;
    vm.toggleExpandAll = toggleExpandAll;
    vm.getPaginationCurrentInfo = getPaginationCurrentInfo;
    
    activate();

    function activate() {
        $scope.$watch(function() { return vm.groupingLevel; }, function() {
            vm.refresh();
        });

        vm.pagination.total = Math.ceil(vm.vitalChanges.length / vm.pagination.max);

        vm.refresh();
    }

    function refresh(){
        vm.expandAll = false;
        computeChangedFields();
        vm.paginatedChanges = getPaginatedChanges();
    }

    function toggleExpand(item){
        item._expand = !item._expand;

        vm.expandAll = vm.paginatedChanges.every(function(check){
            return check._expand;
        });
    }

    function toggleExpandAll(){
        vm.expandAll = !vm.expandAll;
        vm.paginatedChanges.forEach(function(item){
            item._expand = vm.expandAll;
        });
    }

    function getPaginatedChanges(){
        vm.pagination.items = vm.vitalChanges.length;
        var start = (vm.pagination.current - 1) * vm.pagination.max;
        return vm.vitalChanges.slice(start, start + vm.pagination.max);
    }

    
    const currentValueMaxCharacters = 20;
    const suggestedValueMaxCharacters = 40;

    function computeChangedFields(){
        vm.vitalChanges.forEach(function(item){
            item._expand = false;
            item._changedFields = [];
            item._changedFieldsLabels = [];

            vm.fieldDefinitions.forEach(function(field, index){
                var currentKey = 'current' + field.key;
                var suggestedKey = 'suggested' + field.key;
                var currentVal = item[currentKey];
                var suggestedVal = item[suggestedKey];

                // Show if there's a suggestion that differs from current
                if (suggestedVal !== undefined && currentVal !== undefined) {

                    item._changedFieldsLabels.push($translate.instant(field.label))

                    item._changedFields.push(
                    {
                        label: $translate.instant(field.label),
                        current: currentVal === '' ? '(' + $translate.instant('common.empty').toLowerCase() + ')' : currentVal,
                        currentCut: currentVal.length > currentValueMaxCharacters ? currentVal.substring(0, currentValueMaxCharacters) + '...' : undefined,
                        suggested: suggestedVal  === '' ? '(' + $translate.instant('common.empty').toLowerCase() + ')' : suggestedVal,
                        suggestedCut: suggestedVal.length > suggestedValueMaxCharacters ? suggestedVal.substring(0, suggestedValueMaxCharacters) + '...' : undefined,
                    });
                }
            });
        });
    }

    function getPaginationCurrentInfo(){
        var info = $translate.instant('common.showing')
            (((vm.pagination.current - 1) * vm.pagination.max) + 1).toString() + ' - ' +
            (vm.pagination.current * vm.pagination.max).toString() + ' of ' + (vm.pagination.items).toString()
        return info;
    }

    function closeModal(approved) {
        $uibModalInstance.close({approved: approved, disable: vm.disableAuto});
    }
}

angular
    .module('product.productimporteditor.connectVitalArticleInformationDialog', [])
    .service('connectVitalArticleInformationDialogService', connectVitalArticleInformationDialogService)
    .controller('connectVitalArticleInformationDialogController', connectVitalArticleInformationDialogController);